import Berita from 'pages/Berita';
import DocumentGampong from 'pages/DocumentGampong';
import Geografi from 'pages/Geografi';
import Gallery from 'pages/Gallery';
import Kegiatan from 'pages/Kegiatan';
import Layanan from 'pages/Layanan';
import Pemerintahan from 'pages/Pemerintahan';
import Pencapaian from 'pages/Pencapaian';
import Perangkat from 'pages/Perangkat';
import PostBerita from 'pages/PostBerita';
import PostDocument from 'pages/PostDocument';
import PostKegiatan from 'pages/PostKegiatan';
import PostPencapaian from 'pages/PostPencapaian';
import PostPerangkat from 'pages/PostPerangkat';
import QanunGampong from 'pages/QanunGampong';
import Sdg from 'pages/Sdg';
import Sdm from 'pages/Sdm';
import Sejarah from 'pages/Sejarah';
import VisiMisi from 'pages/VisiMisi';
import React, { useMemo, useState } from 'react'
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { userContext } from 'Context/userContext';
// import { useCallback } from 'react';
// import { getProfile } from 'services/apiRoutes';
// import { useEffect } from 'react';
import LandingPage from 'pages/LandingPage';
import Register from 'pages/Register';
import DaftarDesa from 'pages/DaftarDesa';
import Success from 'pages/Success';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Dashboard from 'pages/Dashboard';
import CMSLayout from 'Layout/CMSLayout';
import CMSDashboard from 'pages/CMS/CMSDashboard';
import CMSContentPage from 'pages/CMS/CMSContentPage';
import CMSProfilePage from 'pages/CMS/CMSProfilePage';
import CMSSdmPage from 'pages/CMS/CMSSdmPage';
import CMSGeographyPage from 'pages/CMS/CMSGeographyPage';
import LoginPage from 'pages/CMS/LoginPage';
import UserManagement from 'pages/CMS/UserManagement';
import { AuthProvider } from 'Context/AuthContext';
import ProtectedRoute from 'components/ProtectedRoute';

export default function App() {
  // const {slug}=useParams();
  // const [profile,setProfile]= useState();
  const [prov,setProv]= useState(11);
  const [kab, setKab] = useState(1101);
  const [kec, setKec] = useState(110101);

  const [data,setData]=useState();
   const values = useMemo(
     () => ({
       data,
       setData,
       prov,
       setProv,
       kab,
       setKab,
       kec,
       setKec,
     }),
     [data, setData, prov, setProv, kab, setKab, kec, setKec]
   );

  //  const profileAPI = useCallback(async () => {
  //    const res = await getProfile(slug);
  //    if (res.error) {
  //      return res.message;
  //    } else {
  //      const { data } = res.data;
  //      setProfile(data);
  //    }
  //  }, [slug]);

  //  useEffect(() => {
  //    profileAPI(slug);
  //  }, [profileAPI,slug]);
  return (
    <userContext.Provider
      value={{ values, prov, setProv, kab, setKab, kec, setKec }}
    >
      <AuthProvider>
        <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/:slug" element={<HomePage />} />
        <Route path="/:slug/Kegiatan" element={<Kegiatan />} />
        <Route path="/:slug/Berita" element={<Berita />} />
        <Route path="/:slug/Perangkat" element={<Perangkat />} />
        <Route path="/:slug/Layanan" element={<Layanan />} />
        <Route path="/:slug/Geografi" element={<Geografi />} />
        <Route path="/:slug/gallery" element={<Gallery />} />
        <Route path="/:slug/sdm" element={<Sdm />} />
        <Route path="/:slug/sdg" element={<Sdg />} />
        <Route path="/:slug/pemerintahan" element={<Pemerintahan />} />
        <Route path="/:slug/VisiMisi" element={<VisiMisi />} />
        <Route path="/:slug/Sejarah" element={<Sejarah />} />
        <Route path="/:slug/Pencapaian" element={<Pencapaian />} />
        <Route path="/:slug/qanun" element={<QanunGampong />} />
        <Route path="/:slug/postkegiatan/:id" element={<PostKegiatan />} />
        <Route path="/:slug/postpencapaian/:id" element={<PostPencapaian />} />
        <Route path="/:slug/documents/:id" element={<PostDocument />} />
        <Route path="/:slug/postberita/:id" element={<PostBerita />} />
        <Route path="/:slug/postperangkat/:id" element={<PostPerangkat />} />
        <Route path="/:slug/documents" element={<DocumentGampong />} />
        <Route path="/register" element={<Register />} />
        <Route path="/daftardesa" element={<DaftarDesa />} />
        <Route path="/success" element={<Success />} />
        <Route path="/dashboard" element={<Dashboard />} />
                
          {/* CMS Public Routes */}
          <Route path="/:slug/cms/login" element={<LoginPage />} />
          
          {/* CMS Protected Routes */}
          <Route path="/:slug/cms" element={<ProtectedRoute><CMSLayout><CMSDashboard /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/dashboard" element={<ProtectedRoute><CMSLayout><CMSDashboard /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/profile" element={<ProtectedRoute><CMSLayout><CMSProfilePage /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/berita" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Berita" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/kegiatan" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Kegiatan" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/perangkat" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Perangkat Gampong" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/layanan" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Layanan" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/geografi" element={<ProtectedRoute><CMSLayout><CMSGeographyPage /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/sdm" element={<ProtectedRoute><CMSLayout><CMSSdmPage /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/sdg" element={<ProtectedRoute><CMSLayout><CMSContentPage title="SDG" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/pemerintahan" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Pemerintahan" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/visimisi" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Visi Misi" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/sejarah" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Sejarah" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/pencapaian" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Pencapaian" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/qanun" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Qanun" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/documents" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Dokumen" /></CMSLayout></ProtectedRoute>} />
          <Route path="/:slug/cms/gallery" element={<ProtectedRoute><CMSLayout><CMSContentPage title="Gallery" /></CMSLayout></ProtectedRoute>} />
          
          {/* Superadmin Only Routes */}
          <Route path="/:slug/cms/users" element={<ProtectedRoute requireAdmin={true}><CMSLayout><UserManagement /></CMSLayout></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
      <ToastContainer />
    </userContext.Provider>
  );
}
